/**
 * @ngdoc service
 * @name components.constant:localeFallbacks
 *
 * @description
 *
 */
angular
    .module('festzelt-os.components')
    .value('localeFallbacks', {
        en: 'en-US'
    });



// WEBPACK FOOTER //
// ./src/app/components/values/locale-fallbacks-value.js